export default __webpack_public_path__ + "static/media/ic_comment_primary.713f8061.svg";